import { FC } from 'react'
import { Route, Switch, HashRouter } from 'react-router-dom'
import {
  NotFound,
  ClaimPage,
  CampaignFinished,
  QR,
  HomePage,
  AllLinksClaimed,
  ShortLinkPage
} from 'components/pages'

const AppRouter: FC = () => {
  return <HashRouter>
    <Switch>
      <Route path='/receive'><ClaimPage /></Route>
      <Route path='/qr/:qrId'><QR /></Route>
      <Route path='/claim/:linkKey'><ShortLinkPage /></Route>
      <Route path='/campaign-finished'><CampaignFinished /></Route>
      <Route path='/all-links-claimed'><AllLinksClaimed /></Route>
      
      <Route exact path='/'><HomePage /></Route>
      <Route path='*'><NotFound /></Route>
    </Switch>
  </HashRouter>
}

export default AppRouter